import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import Consegne from "./Consegne";
import Resi from "./Resi";
import { Send, Undo2, Car } from "lucide-react";

export default function Autisti() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin" || user.is_admin;
  const canConsegne = isAdmin || !!user.permissions_effective?.consegne?.view;
  const canResi = isAdmin || !!user.permissions_effective?.resi?.view;
  const [tab, setTab] = useState(canConsegne ? "consegne" : "resi");

  const TabBtn = ({ id, label, Icon }) => (
    <button
      data-testid={`autisti-tab-${id}`}
      onClick={() => setTab(id)}
      className={`flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-semibold border transition-colors ${
        tab === id ? "bg-primary/15 text-primary border-primary/40" : "bg-slate-800 text-slate-400 border-slate-700 hover:text-slate-200"
      }`}
    >
      <Icon className="w-4 h-4" /> {label}
    </button>
  );

  return (
    <div className="animate-fade-up">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-md bg-cyan-500/15 flex items-center justify-center"><Car className="w-6 h-6 text-cyan-300" /></div>
        <h1 className="font-display font-black text-4xl text-slate-50 tracking-tight">Autisti</h1>
      </div>
      <p className="text-slate-400 mb-6">Reparto foto consegne e reparto foto resi — tracciabilità completa.</p>

      <div className="flex flex-wrap gap-2 mb-8" data-testid="autisti-tabs">
        {canConsegne && <TabBtn id="consegne" label="Foto Consegne" Icon={Send} />}
        {canResi && <TabBtn id="resi" label="Foto Resi" Icon={Undo2} />}
      </div>

      {tab === "consegne" && canConsegne && <Consegne embedded />}
      {tab === "resi" && canResi && <Resi embedded />}
    </div>
  );
}
